import { STATUS_PRESENTATION, StatusPresentation } from '../models/hospital-account.model';

export const EMPTY_VALUE = '—';

const AMOUNT_FORMAT = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});

export const formatAmount = (amount: number): string => AMOUNT_FORMAT.format(amount);

export const formatAccountDate = (value: string | null): string => {
  if (!value) return EMPTY_VALUE;
  const [year, month, day] = value.slice(0, 10).split('-');
  return year && month && day ? `${day}-${month}-${year}` : value;
};

export const statusPresentation = (status: string): StatusPresentation =>
  STATUS_PRESENTATION[status as keyof typeof STATUS_PRESENTATION] ?? {
    label: status || 'Desconocido',
    variant: 'neutral',
    className: '',
  };
